export default __webpack_public_path__ + "static/konimpex_logo-cfccc991ba2f6c005397ee039bea5000.jpg";